import { QueryKeys } from "@/constants";
import magicLinkService from "@/services/magic-link";
import { useMutation } from "@tanstack/react-query";
import type { IUserInfo } from "./use-user-info";
import { openMobileView } from "@/signals/mobile-view-signal";
import { useNotificationError } from "@/context/error-provider";
import { ErrorNotificationType } from "@/pages/components/error-notification";
import useUserInfo from "./use-user-info";
import { lowerCaseComparison } from "@/lib/string-util";
// @ts-expect-error -- untyped module
const OldWebsiteUrl = import.meta.env.VITE_BASE_ZCONNECT_URL;
// @ts-expect-error -- untyped module
const VITE_BASE_ZCONNECT_V4_URL = import.meta.env.VITE_BASE_ZCONNECT_V4_URL;

export type IMagicLinkPayload = {
  memberId: string;
  route: string;
  groupId: string;
  divisionId: string;
  source: string;
  careTeamName: string;
};

const useMagicLink = () => {
  const { addError } = useNotificationError();
  const userInfo = useUserInfo();

  const SKINNY_WEB_URL = lowerCaseComparison(userInfo.groupId, "Z5DEMO_F")
    ? VITE_BASE_ZCONNECT_V4_URL
    : OldWebsiteUrl;

  return useMutation({
    mutationFn: (userInfo: IUserInfo) => magicLinkService(userInfo),
    mutationKey: [QueryKeys.OLD_COST_ESTIMATOR],
    onSuccess(data) {
      const magicLinkString = data?.redirectURL;
      if (magicLinkString) {
        const magicLinkURL = new URL(magicLinkString);
        const redirectKey = magicLinkURL.searchParams.get("redirectKey");
        const url = `${SKINNY_WEB_URL}/guest-login?redirectKey=${redirectKey}`;
        // console.log("Magic Link URL", url);
        openMobileView(url);
      }
    },
    onError(error) {
      console.error("Magic Link Error", error);
      addError({
        message: error?.message || "Failed to generate magic link.",
        type: ErrorNotificationType.ERROR,
      });
    },
  });
};

export default useMagicLink;
